import { computed } from 'vue';

import { InjectionWithDefaults } from '../../../types/utils';
import { ModuleInjection } from './Module.types';

export const MODULE_INJECTION: InjectionWithDefaults<ModuleInjection> = Object.freeze({
  key: Symbol('MODULE_INJECTION_KEY'),
  defaults: {
    variant: undefined,
    includeDataviewPagination: computed(() => false),
  },
});
